import React from "react";
import PropTypes from "prop-types";
import UsableDatePicker from "../../../components/datepicker/UsableDatePicker";
import SearchField from "../../../components/common/searchbox/SearchField";
import { owingZeroData } from "../../../locales/en";
import styles from "../../../assets/scss/custom.module.scss";
import "./owingStyle.scss";

function OwingFilter({
  handleStartDateChange,
  handleEndDateChange,
  selectedStartDate,
  selectedEndDate,
  onFilter,
  onDownload,
  loading,
  searchKeyword,
  handleSearchChange,
  handleKeyDown
}) {
  return (
    <div className="main-filter-bar flex-wrap mb-3 owing-filter-container">
      <div className="d-flex flex-wrap justify-content-between align-items-center w-100 gap-3 mb-1 mt-1">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <div>
            <label className="d-block mb-1 text-muted fw-bold filter-label">
              {owingZeroData.filter.fromDate}
            </label>
            <UsableDatePicker
              className={styles.filterDate}
              onChange={handleStartDateChange}
              value={selectedStartDate}
            />
          </div>
          <div>
            <label className="d-block mb-1 text-muted fw-bold filter-label">
              {owingZeroData.filter.toDate}
            </label>
            <UsableDatePicker
              className={styles.filterDate}
              onChange={handleEndDateChange}
              value={selectedEndDate}
            />
          </div>
          <div className="d-flex align-items-center gap-2 mt-4">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={onFilter}
              disabled={loading}
            >
              {owingZeroData.filter.filterBtn}
            </button>
            <button
              type="button"
              className="btn btn-success btn-sm excel-btn"
              onClick={onDownload}
              disabled={loading}
            >
              {owingZeroData.filter.excelBtn}
            </button>
          </div>
        </div>

        <div className="d-flex align-items-center mt-4">
          <SearchField
            tempSearchQuery={searchKeyword}
            handleSearchChange={handleSearchChange}
            handleKeyDown={handleKeyDown}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

OwingFilter.propTypes = {
  handleStartDateChange: PropTypes.func.isRequired,
  handleEndDateChange: PropTypes.func.isRequired,
  selectedStartDate: PropTypes.any,
  selectedEndDate: PropTypes.any,
  onFilter: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  searchKeyword: PropTypes.string,
  handleSearchChange: PropTypes.func,
  handleKeyDown: PropTypes.func
};

export default OwingFilter;
